<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'App',
  components: {},
  data() {
    return {
      app: null,
      releases: null,
      partnumber: null
    }
  },
  methods: {
    getApp() {
      this.$router.beforeEach((to, from, next) => {
        this.app = to.matched[0].components.default.data().app
        sessionStorage.setItem('app', to.matched[0].components.default.data().app)
        next()
      })
    },
    getReleases() {
      if (sessionStorage.token && typeof sessionStorage.token == "string") {
        if (sessionStorage.pid && typeof sessionStorage.pid == "string") {
          axios
            .get(
              process.env.API_LOCATION +
                '/api/release/project/' +
                sessionStorage.pid,
              {
                method: 'GET',
                headers: {
                  'x-auth-token': sessionStorage.token
                }
              }
            )
            .then(response => {
              const content = response.data
              if (content.length != 0) {
                if (content.errors) {
                  this.feedback = content.errors[0].msg
                } else {
                  this.release = content[0]
                  this.releases = content
                  this.partnumber = content[0].part_number
                }
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          this.feedback = 'No Apps For you'
        }
      } else {
        this.feedback = 'No Apps For you'
      }
    },
    handler() {
      if (sessionStorage.getItem('app') != 'undefined') {
        this.app = sessionStorage.getItem('app')
      }
    }
  },
  updated() {
    this.getApp()
  },
  created() {
    this.getApp()
    this.getReleases()
    window.addEventListener('unload', this.handler())
  },
  mounted() {
    if (
      this.$router.currentRoute.name == 'Applications' ||
      this.$router.currentRoute.name == 'Login'
    ) {
      this.app = null
      sessionStorage.removeItem('app')
      sessionStorage.removeItem('sessionId')
    }
    this.getApp()
    window.addEventListener('keydown', (event) => {
      if (event.key === 'F5') {
        event.preventDefault();
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('sessionId')
        if (this.$router.currentRoute.name != 'Login') {
          this.$router.push({name: 'Login'})
        }
      }
    });
    window.addEventListener('popstate', () => {
      if (document.body.classList.contains('driver-active')) {
        // A driver.js tutorial is open; close it instead of signing out
        document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }))
        return
      }
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
      sessionStorage.removeItem('sessionId')
      if (this.$router.currentRoute.name != 'Login') {
        this.$router.push({name: 'Login'})
      }
    });
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle
    }
  }
}
</script>
